import { lazy } from 'react';
import { withSuspense } from '@/hocs/withSuspense';

export const PrintPageLazy = withSuspense(lazy(() => import('./print.page')));
